/**
 * formcontroller
 */

// Smartphone
function editPanel(panelId)
{

    require(
            ["smartController", "Seed", "Seed.Tab"],
            function (smartVersion, Seed) {
                var currentPanel = Seed.Tab.GetFrame().find('#toShow'+panelId);
                Seed.Tab.SetElementChildNumber(currentPanel[0], false, false, true);
                smartVersion.editPanel(panelId);
            },
            function (err) {
                console.error("ERROR: ", err.requireType);
                console.error("MODULES: ", err.requireModules);
            }
    );
}


// Edition2
function callForm(numaction, bbmindex, sImport)
{
    require(["jquery", 'Seed', 'Seed.Tab'], function ($, Seed) {
        Seed.Tab.AddTab();
        Seed.Tab.SetCallback(function callb()
        {
            requestFormulaire(
                    $(Seed.Tab.cTab[0]).attr('id'),
                    numaction,
                    bbmindex,
                    bbmindex,
                    '',
                    sImport
                    );
        });
        Seed.Tab.GetCallback();
    });
}



/**
 * Appelle un formulaire
 *
 * @param numcontent
 * @param numAction n° de l'action
 * @param bbmIndex clef interne
 * @param pOwnerKey
 * @param pOwnerSearch
 * @param pImport
 */
function requestFormulaire(numcontent, numAction, bbmIndex, pOwnerKey, pOwnerSearch, pImport)
{
    require(["jquery", "resizeScreen", "Seed", "parameter", "Seed.Ajax"], function ($, resizeScreen, Seed, parameter) {
        var sImport = "";
        if (pImport) {
            var pImportLength = pImport.length;
            for (var i = 0; i < pImportLength; i++) {
                sImport += "&" + pImport[i][0] + "=" + parameter.encodeParam(pImport[i][1]);
            }
        }

        var pTarget = document.getElementById("tab_" + Seed.Tab.cTab.attr("id"));
        var numcontentform = 0;
        numcontentform = eval(numcontent) + 1;
        Seed.Ajax.Post({
//            url: root + "_module/Edition2.php",
            url: root + "_module/ListAndForm/FormCore.php",
            data: "valeurCle=" + bbmIndex
                    + "&numcontent=" + numcontentform
                    + "&numaction=" + numAction
                    + sImport
                    + "&moduleType=" + moduleType,
            json: true,
            async: true,
            success: function (xml) {
                $(pTarget).html(xml.html);
                var jscript = document.createElement("SCRIPT"); // BALISE SCRIPT
                jscript.text = xml.jscript;
                pTarget.appendChild(jscript); // AJOUT DU SCRIPT AU DOCUMENT

                // Redimensionnement de la grille
                resizeScreen.resizeScreen();
                $('#bench').html(xml.bench);
            }
        });
    });
}

function initializeForm(fieldName, libelle, bbmindex, dateValues)
{
    require(
            ["Seed", "Seed.Tab", "bootstrap-datetimepicker", "formController", "bootstrap-colorpicker"],
            function (Seed) {
                multiScript(fieldName, libelle, bbmindex);
                setDate(dateValues);
                multiScript2();
                Seed.Tab.GoToPosition();
            }
    );
}

/**
 * @param {string} fieldName
 * @param {string} libelle
 * @param {int} bbmindex
 */
function multiScript(fieldName, libelle, bbmindex)
{
    require(
            ['jquery', 'moment', 'autosize', 'Seed', 'parameter',
                'bootstrap', 'bootstrap-datetimepicker',
                'Seed.Tab', 'signatureController'],
            function ($, moment, autosize, Seed, parameter) {
                // Nom de l'onglet
                if (fieldName) {
                    var element = Seed.Tab.GetFrame().find("#" + fieldName);
                    if (element.length !== 0) {
                        var elementValue = $(element).val();
                        libelle = parameter.encodeParam(libelle + ':' + elementValue);
                    }
                }
                Seed.Tab.SetText(libelle);

                var pTarget = Seed.Tab.GetFrame();
                Seed.Tab.GetFrame().find('.SM-datepicker')
                        .parent()
                        .find('button')
                        .click(function (event) {
                            $(this).parent().parent()
                                    .find('input')
                                    .data('DateTimePicker').show();
                        });
                Seed.Tab.GetFrame()
                        .find('.SM-datetimepicker')
                        .parent()
                        .find('button')
                        .click(function (event) {
                            $(this).parent().parent()
                                    .find('input')
                                    .data('DateTimePicker').show();
                        });
                Seed.Tab.GetFrame().find('.SM-timepicker').parent()
                        .find('button')
                        .click(function (event) {
                            $(this).parent().parent()
                                    .find('input')
                                    .data('DateTimePicker').show();
                        });
                // Date
                $(pTarget).find(".SM-datepicker").datetimepicker({
                    locale: moment.locale(),
                    icons: {
                        time: 'fa fa-clock-o',
                        date: 'fa fa-calendar-o',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-angle-left',
                        next: 'fa fa-angle-right',
                        today: 'fa fa-crosshairs',
                        clear: 'fa fa-trash'
                    },
                    showTodayButton: true,
                    showClear: true,
                    format: "L",
                    useCurrent: false
                });
                // DateHeure
                $(pTarget).find(".SM-datetimepicker").datetimepicker({
                    locale: moment.locale(),
                    icons: {
                        time: 'fa fa-clock-o',
                        date: 'fa fa-calendar-o',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-angle-left',
                        next: 'fa fa-angle-right',
                        today: 'fa fa-crosshairs',
                        clear: 'fa fa-trash'
                    },
                    showTodayButton: true,
                    showClear: true,
                    format: "L LT",
                    useCurrent: false
                });
                // Heure
                $(pTarget).find(".SM-timepicker").datetimepicker({
                    locale: moment.locale(),
                    icons: {
                        time: 'fa fa-clock-o',
                        date: 'fa fa-calendar-o',
                        up: 'fa fa-arrow-up',
                        down: 'fa fa-arrow-down',
                        previous: 'fa fa-angle-left',
                        next: 'fa fa-angle-right',
                        today: 'fa fa-crosshairs',
                        clear: 'fa fa-trash'
                    },
                    format: "LT",
                    useCurrent: false
                });
                // colorpicker
                $(pTarget).find('.color').colorpicker({format: 'hex'})
                        .on('hidePicker', function (e) {
                            var tmp = $(this).children()[0];
                            $(tmp).trigger('change');
                        });
                // autosize
                var autosizes = $(pTarget).find('textarea.textarea');
                $(autosizes).css('transition', 'height 0.2s ease 0s');
                $(autosizes).css('height', '50px');
                $(autosizes).css('min-height', '50px');
                $(autosizes).css('max-height', '180px');
                $(autosizes).css('resize', 'none');
                autosize($(autosizes));
                //Bind des tooltips eventuelles
                $(pTarget).find('.bt_tooltip').tooltip({container: 'body'});
                // Barre de boutons vide
                $(pTarget).find('.buttonBar:empty').hide();
                // scrollspy & affix
                $('[data-spy=\"scroll\"]').each(function () {
                    var spy = $(this).scrollspy('refresh');
                });
                // Modal et signature
                $("#modalIframeContent").off("hidden.bs.modal");
                $("#modalIframeContent").on("hidden.bs.modal", function () {
                    signCheck(bbmindex);
                });
                Seed.Tab.SetVisibility();
            }
    );
}

function setDate(values)
{
    require(
            ['jquery', 'moment',
                'bootstrap', 'bootstrap-datetimepicker',
                'Seed.Tab', 'signatureController'],
            function ($, moment) {
                if (values !== null && typeof values === 'object') {
                    for (var i = 0; i < values.length; i++) {
                        for (var key in values[i]) {
                            var value = values[i][key];
                            var data = $("#" + key).data("DateTimePicker");
                            if (typeof data !== "undefined") {
                                data.date(moment(value));
                            }
                        }
                    }
                }
            }
    );
}

function multiScript2()
{
  require(
    ['jquery', "Seed", "Seed.Tab"],
    function ($, Seed) {
      var pTarget = Seed.Tab.GetFrame();
      $(pTarget).find(".SM-timepicker").on("dp.show", function (e) {
        pTarget.withKeyboard = false;
        pTarget.originalDate = e.currentTarget.value;
        pTarget.onchangeDate = $(this)[0].attributes["data-onchange"].value;
      });
      $(pTarget).on('keypress', 'input.SM-timepicker', function(e){
        pTarget.withKeyboard = true;
      });
      $(pTarget).find(".SM-timepicker").on("dp.change", function (e) {
        if (pTarget.originalDate !== e.currentTarget.value && pTarget.originalDate !== undefined && pTarget.withKeyboard) {
          pTarget.withKeyboard = false;
          eval(pTarget.onchangeDate);
          pTarget.onchangeDate = undefined;
        }
      });
      $(pTarget).find(".SM-timepicker").on("dp.hide", function (e) {
        if (!pTarget.withKeyboard) {
          eval(pTarget.onchangeDate);
          pTarget.onchangeDate = undefined;
        }
      });

      $(pTarget).find(".SM-datepicker").on("dp.show", function (e) {
        pTarget.withKeyboard = false;
        pTarget.originalDate = e.currentTarget.value;
        pTarget.onchangeDate = $(this)[0].attributes["data-onchange"].value;
      });
      $(pTarget).on('keypress', 'input.SM-datepicker', function(e){
        pTarget.withKeyboard = true;
      });
      $(pTarget).find(".SM-datepicker").on("dp.change", function (e) {
        if (pTarget.originalDate !== e.currentTarget.value && pTarget.originalDate !== undefined && pTarget.withKeyboard) {
          pTarget.withKeyboard = false;
          eval(pTarget.onchangeDate);
          pTarget.onchangeDate = undefined;
        }
      });
      $(pTarget).find(".SM-datepicker").on("dp.hide", function (e) {
        if (!pTarget.withKeyboard) {
          eval(pTarget.onchangeDate);
          pTarget.onchangeDate = undefined;
        }
      });

      $(pTarget).find(".SM-datetimepicker").on("dp.show", function (e) {
        pTarget.withKeyboard = false;
        pTarget.originalDate = e.currentTarget.value;
        pTarget.onchangeDate = $(this)[0].attributes["data-onchange"].value;
      });
      $(pTarget).on('keypress', 'input.SM-datetimepicker', function(e){
        pTarget.withKeyboard = true;
      });
      $(pTarget).find(".SM-datetimepicker").on("dp.change", function (e) {
        if (pTarget.originalDate !== e.currentTarget.value && pTarget.originalDate !== undefined && pTarget.withKeyboard) {
          pTarget.withKeyboard = false;
          eval(pTarget.onchangeDate);
          pTarget.onchangeDate = undefined;
        }
      });
      $(pTarget).find(".SM-datetimepicker").on("dp.hide", function (e) {
        if (!pTarget.withKeyboard) {
          eval(pTarget.onchangeDate);
          pTarget.onchangeDate = undefined;
        }
      });
    }
  );
}

/**
 * Déplacment vers un élément de la page
 * @param {type} dataArray tablean contenant l'id Sidebar et l'ance associé
 */
function smoothScrolling(dataArray)
{
    require(["Seed", "Seed.Tab"], function (Seed) {
//    var idSideBar = dataArray[0];
        var idAnchor = dataArray[1];
        $('html, body')
                // on arrête toutes les animations en cours
                .stop()
                /* on fait maintenant l'animation vers le haut (scrollTop) vers
                 notre ancre Id */
                .animate(
                        {
                            scrollTop: $('#' + idAnchor).offset().top - Seed.Tab.GetFrame()
                                    .find('.edition2').offset().top
                        },
                        1500
                        );
    });
}

function formSendMail(message, param)
{
    require(
            ["bootbox", "processLauncher", "Seed", "Seed.Tab"],
            function (bootbox, processLauncher, Seed) {
                bootbox.confirm(message, function (result) {
                    if (result === true) {
                        processLauncher.processPHP('php_spec/envoimail.php?'
                                + 'nometat=' + Seed.Tab.GetFrame()
                                .find('#listeedition').val(), param);
                    }
                });
            }
    );
}

function imprimerForm(
        pTargetTable,
        pSourceTable,
        pKeyValue,
        pRefreshedList,
        pCreationAuto,
        pNumAction,
        pOwnerKey,
        pPreviousResult
        ) {

    require(["printer"], function (printer) {
        printer.imprimerForm(pTargetTable, pSourceTable, pKeyValue, pRefreshedList, pCreationAuto, pNumAction, pOwnerKey, pPreviousResult);
    });

}
;
define("formController", function(){});

